module.exports = __webpack_public_path__ + "images/signal_3.f7627e85c74f4336bad83d977757a21f.png";